import type { Course } from "@/types";

export const JAZZ_PIANO_EXPANSIONS_SLUG = "jazz-piano-expansions";

export function courseThumbnailUri(course: Course): string | null {
  return (
    course.thumbnail ||
    course.avatar_url_desktop ||
    course.avatar_url_mobile ||
    course.desktop_banner_url ||
    course.mobile_banner_url ||
    null
  );
}

/** Dashboard hero — prefer matched course art, else Jazz Piano Expansions. */
export function resolveDashboardThumbnailUri(
  dashboardCourse: Course | undefined,
  courses: Course[],
): string | null {
  if (dashboardCourse) {
    const uri = courseThumbnailUri(dashboardCourse);
    if (uri) return uri;
  }
  const expansions = courses.find((c) => c.slug === JAZZ_PIANO_EXPANSIONS_SLUG);
  return expansions ? courseThumbnailUri(expansions) : null;
}
